import { Flex, Box, Grid } from "styled-system/jsx";
import {
  CloudinaryImage,
  LoadingPage,
  PoweredByWhereabouts,
  WhereaboutsLogo,
} from "shared/components";
import { PropsWithChildren } from "react";
import { Button, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { handleBeaconClick, isLandscape } from "shared/utils";
import { useOnboardingContext } from "./OnboardingContext";
import { css } from "styled-system/css";
import { limitFill } from "@cloudinary/transformation-builder-sdk/actions/resize";
import { getYear } from "date-fns";
import { autoGravity } from "@cloudinary/transformation-builder-sdk/qualifiers/gravity";

export const OnboardingLayout = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  const { organizationId, organization, organizationLoading } =
    useOnboardingContext();
  const { screen } = useOnboardingContext();
  const isOnboardingFromOrg = organization && organizationId;

  return (
    <Flex
      bg={"bg.wa.light"}
      w={"svw"}
      minH={"svh"}
      px={{ base: "400", md: "800" }}
      py={{ base: "600", md: "1000" }}
      overflow={"hidden"}
    >
      {organizationLoading ? (
        <LoadingPage bg={"bg.wa.light"} alignSelf={"center"} />
      ) : (
        <Flex
          w={"full"}
          flexDir={"column"}
          justifyContent={"space-between"}
          alignItems={"center"}
          gap={"600"}
        >
          {isOnboardingFromOrg ? (
            <CloudinaryImage
              image={organization.logo}
              imageStyleProps={{
                objectFit: "scale-down",
                className: css({
                  h: "130px",
                  w: "260px",
                }),
              }}
              resize={
                isLandscape(organization.logo)
                  ? limitFill().width(260).gravity(autoGravity())
                  : limitFill().height(130).gravity(autoGravity())
              }
            />
          ) : (
            <WhereaboutsLogo width={208} height="auto" />
          )}
          {children}
          <Grid w={"full"} alignItems={"center"} h={"48px"}>
            <Box
              gridColumnStart={1}
              gridRowStart={1}
              justifySelf={{ base: "flex-start", md: "center" }}
              maxW={"calc(100% - 90px)"}
            >
              {isOnboardingFromOrg ? (
                <PoweredByWhereabouts />
              ) : (
                <Text
                  visual={"smallSemiBold"}
                  color={"text.light"}
                  justifySelf={"center"}
                  whiteSpace={"wrap"}
                >
                  The Tourism Technology Company ©{getYear(new Date())}
                </Text>
              )}
            </Box>
            {screen !== "get-in-touch" && (
              <Button
                size={"lg"}
                gridColumnStart={1}
                gridRowStart={1}
                justifySelf={"right"}
                visual={"success"}
                onClick={handleBeaconClick}
              >
                {t("core:SUPPORT")}
              </Button>
            )}
          </Grid>
        </Flex>
      )}
    </Flex>
  );
};
